import React, { useEffect, useState } from 'react'
import { handleValidateCodevalue, indianStates } from '../Utility/constant'
import { StyledLeadContainer, StyledSubHeader,StyledGridContainer } from './Styled'
import { TextField } from '@mui/material'
import { useSelector } from 'react-redux'
import TextFiledWithLabel from './TextFieldWithLabel'
import SelectBoxWithLabel from './SelectBoxWithLable'
import { useIsMobile } from '../Utility/hooks/useIsMobile'
import { COUNTRY_LIST } from '../Utility/countryCodes'

const AddressFields = ({ setEntityDetails,entityDetails,onChange , disabled = false}) => {
    
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [isIndia, setIsIndia] = useState(false);
    const isMobile = useIsMobile();
           useEffect(()=>{
                   if(entityDetails?.country == "India"){
                       setIsIndia(true)
                   }
                   else{
                    setEntityDetails ({
                        ...entityDetails,
                        state : "Other"
                    })
                       setIsIndia(false)
                   }
               },[entityDetails?.country])
  return (<>
  <StyledSubHeader>
                   {handleValidateCodevalue(internationalise,'COMMON_ADDRESS')}
                  </StyledSubHeader>
                  
                    <StyledLeadContainer  sx={{
                    width: isMobile ? "100% !important" :  "67.5% !important",
                }}>
                 <TextField
                        fullWidth
                        sx = {{width: "100% !important"}}
                        disabled = {disabled}
                        id="address" 
                        name="address"
                         variant='standard'
                        value={entityDetails?.address || ""}
                        onChange={onChange}
                        label = {handleValidateCodevalue(internationalise,'COMMON_REG_ADD')}
                    />
                    </StyledLeadContainer>
                    <StyledGridContainer> 
                        <SelectBoxWithLabel
                            disabled = {disabled}
                            variant='standard'
                            name = "country"
                            value={entityDetails?.country || ''}
                            label = {handleValidateCodevalue(internationalise,'COMMON_COUNTRY')}
                            onChange={onChange} 
                            optionMenuItem={COUNTRY_LIST}
                            handleOnChange={onChange}
                        />
                        <SelectBoxWithLabel
                            disabled = {(isIndia ? false : true ) || disabled}
                            name= "state"
                            value= { isIndia ? entityDetails?.state : "Other"}
                            label = {handleValidateCodevalue(internationalise,'COMMON_STATE')}
                            handleOnChange={onChange}
                            variant='standard'
                            optionMenuItem={indianStates}
                        />
                        <TextFiledWithLabel
                            disabled = {disabled}
                            id="city" 
                            name="city"
                            value={entityDetails?.city || ""}
                            variant='standard'
                                    
                            handleOnChange={onChange}
                            label = {handleValidateCodevalue(internationalise,'COMMON_CITY')}
                        />
                    </StyledGridContainer>
                    </>
  )
}

export default AddressFields